const STATUS = {
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED",
  SEC_SIGNED: "SEC_SIGNED",
  STUDENT_SIGNED: "STUDENT_SIGNED",
  COMPLETED: "COMPLETED",
  DELETED: "DELETED",
  MAIL_SENT: "MAIL_SENT",
  ACTIVE: "ACTIVE",
};

export { STATUS };
